/* eslint-disable camelcase */

export default {
	//My tests
	mytest: 'Mine tester',
	bibliotek: 'Bibliotek',
	createnewtest: 'Opprett ny test',
	started: 'Påbegynt',
	starttest: 'Start test',
	all: 'Alle',
	distributed: 'Distribuert',
	notdistributed: 'Ikke distribuert',
	notstarted: 'Ikke startet',
	completed: 'Fullført',
	completeplural: 'Fullførte:',
	seeresults: 'Se resultater',
	status: 'Status ',
	testkey: 'Testnøkkel',
	type: 'Type',
	recipient: 'Mottaker',
	actions: 'Handlinger',
	deleatedat: 'Slettet på',
	send: 'Send',
	save: 'Lagre',
	sendcodeemail: 'Send testnøkkel på epost',
	norway: 'Norge',
	sweden: 'Sverige',
	germany: 'Tyskland',
	england: 'Storbritannia',
	nederland: 'Nederland',
	totalnew: 'Nye/Totalt',
	message_testcannotbedeleted:
		'Testen må være minst 3 måneder gammel for å bli slettet.',
	warning_deletetest:
		'Testen vil ikke lenger være tilgjengelig for vurdering. Er du sikker på at du vil fortsette?',
	dynamicheaderfortestresult_child: 'DETALJERTE RESULTATER FOR DYSMATE {0} ',
	handbooktitle:
		'{0} På denne siden finner du nyttige ressurser for bruk av Dysmate',
	dynamicheaderfortestreport_child: 'DETALJERT RAPPORT FOR DYSMATE  {0} ',
	dynamicheaderfortestcandidate_child:
		'DETALJERTE KANDIDATOPPLYSNINGER FOR DYSMATE {0} ',
	dynamicheaderfortestresult_adult: 'DETALJERTE RESULTATER FOR DYSMATE {0} ',
	dynamicheaderfortestreport_adult: 'DETALJERT RAPPORT FOR DYSMATE  {0} ',
	dynamicheaderfortestcandidate_adult:
		'DETALJERTE KANDIDATOPPLYSNINGER FOR DYSMATE {0} ',
	incompleteMessage:
		'Denne testen er ikke komplett, og noen deltester mangler eller er ikke gjennomført enda',
	summary: 'Oppsummering av {0}',
	printtestresults: 'Print testresultater',
	zscorered: 'Z-skåre er mer enn 1 standardavvik {0} gjennomsnittet',
	zscoregreen: 'Z-skåre er mer enn 1 standardavvik {0} gjennomsnittet',
	zscoreblue: 'Z-skåre er innen gjennomsnittetsområdet',
	months: 'måneder',
	translateToNynorsk: 'Oversett til nynorsk',
	exportToConexus: 'Eksporter til Conexus',
	overview: 'Oversikt',
	assessment: 'Vurdering: ',
	assessmentspeechok:
		'{0} har oppnådd resultater som ligger i gjennomsnittsområdet eller bedre for eksperimentell Ett Minutt Test, og ser derfor ut til å ha gode leseferdigheter',
	assessmentspeechnotok:
		'{0} har oppnådd resultater som ligger under gjennomsnittsområdet for eksperimentell Ett Minutt Test, og bør derfor utredes videre med tanke på dysleksi og/eller leseforståelsesvansker',
	asessmenttextok_1:
		'{0} har oppnådd resultater som ligger i gjennomsnittsområdet eller bedre for {1} av testene, og ser derfor ut til å ha gode lese- og skriveferdigheter',
	asessmenttextnotok_1:
		'{0} har oppnådd resultater som ligger under gjennomsnittsområdet på {1} av de {2} testene, og bør derfor utredes videre med tanke på dysleksi og/eller leseforståelsesvansker',
	assesmenttextok_youthfollowup:
		'{0} har ingen utslag på de typiske kognitive markørene på dysleksi.',
	assesmentok_recommendation_youthfollowup:
		'Dersom {0} likevel har oppnådd skårer under gjennomsnittsområdet på Leseprøven og/eller Ordforståelse, eller eventuelt på noen av de andre av testene i DYSMATE screeningtest, anbefales en videre kartlegging med tanke på mulig leseforståelsessvikt og/eller mulig underliggende utviklingsmessige språkforstyrrelse (DLD).',
	workingmemorylowassesment:
		'{0} har utslag på Arbeidsminne, og oppnår en skåre som ligger {1} standardavviksenheter under gjennomsnittet for sitt trinn eller sin alder på denne testen. Arbeidsminne er i seg selv ikke en kognitiv markør på dysleksi, men er assosiert med både dysleksi og leseforståelsessvikt. Redusert arbeidsminne kan blant annet påvirke hvor mye informasjon man greier å få med seg fra lest tekst. Det anbefales derfor å undersøke i hvor stor grad arbeidsminnet til {2} påvirker tilegnelsen av nytt fagstoff, og om det er behov for skolefaglig tilrettelegging rundt dette.',
	rapidnominationlowassesment:
		'{0} har utslag på Hurtigbenevning, og oppnår en skåre som ligger {1} standardavviksenheter under gjennomsnittet for sitt trinn eller sin alder på denne testen. Hurtigbenevningstesten måler hvor raskt og nøyaktig man greier å hente frem ord fra språkminnet. Svake ferdigheter på dette området er en kognitiv markør på dysleksi.',
	oneminutelowassesment:
		'{0} har utslag på Ettminuttstesten, og oppnår en skåre som ligger {1} standardavviksenheter under gjennomsnittet for sitt trinn eller sin alder. Ettminuttstesten gir et rent mål på antallriktig leste ord per minutt, og gir et godt bilde av avkodingsferdigheter. Svake avkodingsferdigheter er en markør på dysleksi.',
	oneminutelowassesment2:
		'NB! Det anbefales å vurdere resultatene på Ettminuttstesten i sammenheng med resultatene på Diktatprøven og Ordkjedetesten på DYSMATE screeningtest.',
	spoonerismlowassesment:
		'{0} har utslag på Spoonerism, og oppnår på denne testen en skåre som ligger {1} standardavviksenheter under gjennomsnittet for sitt trinn eller sin alder. Spoonerism-testen måler fonembevissthet og fonologisk prosesseringshastighet. Svake ferdigheter på disse områdene er en kognitiv markør på dysleksi.',
	fonemutelatelselowassesment:
		'{0} har utslag på Fonemutelatelse, og oppnår på denne testen en skåre som ligger {1} standardavviksenheter under gjennomsnittet for sitt trinn eller sin alder. Fonemutelatelse-testen måler fonembevissthet og fonologisk prosesseringshastighet. Svake ferdigheter på disse områdene er en kognitiv markør på dysleksi.',

	assessmentokBHtest:
		'{0} har oppnådd resultater som ligger i gjennomsnittsområdet eller bedre for testene, og ser ut til å ligge på det nivå som er typisk for sin alder på områder som er viktig for å utvikle gode lese- og skriveferdigheter.',
	assessmentBHonlyLK:
		'{0} har lavere enn forventet bokstavkunnskap for trinnet. Dette kan ha sammenheng med fremgangsmåten for bokstavinnlæringen på skolen. Det anbefales likevel at man følger nøye med utviklingen i elevens bokstav-lyd-innlæring.',
	assessmentBHRI:
		'{0} har utslag på Hurtigbenevning, og oppnår en skåre som ligger {1} standardavviksenheter under gjennomsnittet for sitt trinn på denne testen. Hurtigbenevningstesten måler hvor raskt og nøyaktig man greier å hente frem ord fra språkminnet. Svake ferdigheter på dette området er en kognitiv markør på dysleksi',
	assessmentBHWM:
		'{0} har utslag på Arbeidsminne, og oppnår en skåre som ligger {1} standardavviksenheter under gjennomsnittet for sitt trinn på denne testen. Arbeidsminne er i seg selv ikke en kognitiv markør på dysleksi, men er assosiert med både dysleksi og leseforståelsessvikt. Redusert arbeidsminne kan blant annet påvirke hvor mye informasjon man greier å få med seg fra lest tekst. Det anbefales derfor å undersøke i hvor stor grad arbeidsminnet til {2} påvirker tilegnelsen av nytt fagstoff, og om det er behov for skolefaglig tilrettelegging rundt dette.',
	assessmentBHFI:
		'{0} har utslag på Fonemisolasjon, og oppnår på denne testen en skåre som ligger {1} standardavviksenheter under gjennomsnittet for sitt trinn. Fonemisolasjonstesten måler fonembevissthet og fonologisk prosesseringshastighet. Svake ferdigheter på dette området er en kognitiv markør på dysleksi.',
	assessmentBHFU:
		'{0} har utslag på Fonemutelatelse, og oppnår på denne testen en skåre som ligger {1} standardavviksenheter under gjennomsnittet for sitt trinn. Fonemutelatelsestesten måler fonembevissthet og fonologisk prosesseringshastighet. Svake ferdigheter på dette området er en kognitiv markør på dysleksi.',

	rawscore: 'Råskåre',
	zscore: 'Z-Skåre',
	percentilescore: 'Percentilskåre',
	tscore: 'T-Skåre',
	scaledscore: 'Skalert skåre',
	assessmentsubtestnormal: 'Denne skåren er i gjennomsnittsområdet',
	theAverage: 'gjennomsnittet.',
	assessmentsubtestbelow: 'Denne skåren ligger {0} standardavvik {1}',
	under: 'under',
	clearlyover: 'klart over', // zscore +1.01 <+2
	within: 'innenfor', // zscore -1 < +1
	over: 'over',
	workingmemorytest: 'Arbeidsminne',
	spoonerismtest: 'Spoonerism',
	fonemutelatelsetest: 'Fonemutelatelse',
	rapidautonamingtest: 'Hurtigbenevning',
	oneminutetest: 'Ettminutttest',
	letterknowledgetest: 'Bokstavkunnskap',
	/* literatePrivacyPolicy: 'Literates personvernerklæring', */
	classGrade: 'Klassetrinn',
	grade: 'trinn',
	constTestYouth:
		'Som testadministrator så bekrefter du at du har nødvendig samtykke fra Testkandiaten til å innhente personopplysninger og at disse brukes som beskrevet i Literates {0}',
	constTestChild:
		'Som testadministrator så bekrefter du at du har nødvendig samtykke til å innhente personopplysninger og at disse brukes som beskrevet i Dysmates {0}',
	privacyPolicy: 'personvernerklæring',
	iConsent: 'Jeg bekrefter:',
	phonemisolationtest: 'Fonemisolasjon',
	worddictationtest: 'Orddiktat',
	phonemeomissiontest: 'Fonemutelatelse',
	nonwordtest: 'Tulleordtesten',
	typingspeedtest: 'Skrivehastighet',
	readingtest: 'Leseprøven',
	wordcomprehensiontest: 'Ordforståelse',
	swapsoundtest: `Byttelyd`,
	loggin: 'Logg inn',
	loggout: 'Logg ut',
	users: 'Brukere',
	needsapproval: 'Trenger godkjenning',
	notcompletedregistration: 'Ikke fullført registrering',
	trialperiod: 'Prøveperiode',
	trialuser: 'Prøvebruker',
	name: 'Navn: ',
	born: 'Født: ',
	firstname: 'Fornavn',
	lastname: 'Etternavn',
	dateofbirth: 'Fødselsdato: ',
	birthDate: 'Fødselsdato',
	continue: 'Fortsett',
	paneMessageContinueTest:
		'Dette vil sende en ny lenke til testkandidaten for å fortsette testen som ikke ble fullført tidligere. Vil du fortsette?',
	telephone: 'Telefon',
	email: 'E-post',
	edit: 'Endre',
	adulttests: 'Voksentester',
	youthtests: 'Ungdomstester',
	sex: 'Kjønn',
	male: 'Mann',
	female: 'Kvinne',
	education: 'Utdanning',
	from: 'Fra:',
	to: 'Til:',
	loggedIn: 'Innlogget',
	blocked: 'Blokkert',
	blockuser: 'Blokker bruker',
	unblockuser: 'Ublokker bruker',
	country: 'Land:',
	allcountries: 'Alle land',
	cancel: 'Avbryt',
	confirm: 'Bekreft',
	age: 'Alder',
	age_specified: 'Alder (år)',
	testdate: 'Testdato',
	childtest: 'Barnetest',
	experimentalchildtest: 'Eksperimentell Barnetest',
	youthtest: 'Youth-screening',
	adultscreening: 'Screeningtest for voksne',
	youthscreening: 'Screeningtest for ungdom',
	childtests: 'Barnetester',
	nousedtests: 'Ingen brukte {0} tester',
	used: 'Brukte:',
	boy: 'Gutt',
	girl: 'Jente',
	logg: 'Hendelseslogg',
	of: 'av {0}',
	wordsperminute: 'ord per minutt',
	deleteoldtests: 'Slett gamle tester',
	trashcan: 'Søppelbøtte',
	addtesttogroup: 'Del i gruppe',
	message_incompletData: 'Ugyldige eller ufullstendige data',
	testcandidateremoved: 'Testkandidat er fjernet fra Klassen',
	testcandidateadded: 'Testkandidat lagt til klassen',
	classexistchoosename:
		'Klassen finnes allerede, vennligst velg et annet navn.',
	class: '.trinn',

	//Mysubscription page
	subscription: 'Abonnement',
	supersubscription: 'sitt abonnement',
	mysubscription: 'Mitt abonnement',
	seetests: 'Se tester',
	teststhismonths: 'Tester denne måneden',
	coststhismonth: 'Kostnader denne måneden',
	currencysymbol: 'NOK',
	hideWithArrow: 'Skjul ▲',
	showearliermonths: 'Se tidligere måneder ▼',
	previousperiods: 'Tidligere perioder',
	period: 'Periode',
	tests: 'Tester',
	costs: 'Konstander',
	yourtrialperiodhasexpired: 'Din prøveperiode har utløpt',
	upgradeyoursubscription: 'Oppgrader ditt abonnement',
	downloadandsendcontract:
		'For å ta flere tester må du tegne et abonnement. Gå inn på «Min side» på literate.no for å bestille abonnement, eller last ned kontrakt og send til ',
	priceandconditioninfo: '. Prisinformasjon og betingelser finnes på ',
	downloadcontract: 'Last ned kontrakt',
	onlytwotestspertrialperiod:
		'Kun to tester av hver type er tilgjengelig i prøveperioden',
	upgradetofullsubscription:
		'oppgrader til fullt abonnement for å opprette nye tester',
	fetch: 'Gjenopprett',
	language: 'Språk',
	singleChild: 'Barn',
	selectedTestAddedToGroup: 'Valgte {0} lagt til i gruppen',
	selectedTestRemovedFromGroup: 'Valgte {0} fjernet fra grupper',
	youth: 'Ungdom',
	adult: 'Voksen',
	youthfollowuptest: 'Ungdom-Oppfølgingstest',
	adultfollowuptest: 'Voksen-Oppfølgingstest',
	childfollowuptest: 'Barn-Oppfølgingstest',
	deletedon: 'Slettet på',
	basic: 'Basic',
	deletedtests: 'Slettede tester',
	viewsubscription: 'Se abonnement ▼',
	viewdeleted: 'Slettede tester ▼',
	referalinformation: 'sin informasjon',
	referalgroups: 'sine grupper',
	mygroups: 'Mine grupper',
	myinformation: 'Mine opplysninger',

	//NewTestModel
	test_type: 'Testtype',
	screeningtest_adult: 'Screeningtest (voksen)',
	numberoftests: 'Antall tester (maks 60)',
	create_tests: 'Opprett nye tester',
	//Login
	loginwithbankid:
		'Logg inn med Feide eller BankID ved å trykke på en av knappene under',
	message_thisisforcertifieduser:
		'Dette er for testadministrator (dvs. sertifiserte brukere med abonnement) ',
	bankid: 'BankID',
	bankidonmobile: 'BankID på Mobil',
	//TestadminModel
	edittestadministrator: 'Endre testadministrator',
	personalinformation: 'Personalia',
	shcool_or_company: 'Skole/bedrift',
	addanewtestadministrator: 'Legg til en ny testadministrator',
	addtestadministrator: 'Legg til testadministrator',
	saveuserinformation: 'Lagre kandidatopplysninger',
	delete: 'Slett',
	deleteuser: 'Slett bruker',
	currentstatus: 'Nåværende status: ',
	savesubscription: 'Lagre abonnement',
	organization: 'Organisasjon',
	//constants/Users
	fullname: 'Fullstendig navn',
	inactive: 'Inaktiv',
	message_nouserswiththestatus: 'Ingen brukere med status {0}',
	message_confirmation:
		'Dette vil sende en bekreftelse til brukerens epost, og gi brukeren tilgang til å begynne prøveperiode.',

	//Registration
	createnewuser: 'Lag ny bruker',
	success: 'Suksess!',
	newuser: 'Ny Bruker',
	newloginmethod: 'Ny Innloggingsmetode',
	errorhasoccured: 'En feil har oppstått',
	message_change_loginmethod:
		'Du er i ferd med å endre påloggingsmetoden. Husk å logge på med samme legitimasjon neste gang',
	info_for_professional_with_either_completed_screening_test:
		'Dette er for fagpersoner som enten har gjennomført, eller som har meldt seg på, sertifiseringskurs og som ønsker å prøve Dysmate screeningtest før man tegner fullt abonnement.',
	info_prerequisites_to_obtain_license:
		'For å få prøvelisens må man ha gjennomført eller meldt seg på Dysmate sertifiseringskurs. Alle registreringer godkjennes manuelt, og ved godkjenning sendes en e-post med informasjon for å fullføre registreringen',
	//Alltests & single child test
	removefiltering: 'Fjern filtering',
	printreport: 'Lagre eller print testrapport',
	printwithcomment: 'Lagre eller print {0}',
	testresult: 'Lagre eller print testresultater',
	testreport: 'testrapport',
	hide: 'Skjul ',
	userinformation: 'Kandidatopplysninger',
	localizedwriteuptextforNormalresults:
		'{0} oppnår resultater som er {1} {2} {3} gjennomsnittsområdet på {4} av deltestene. Dette indikerer at {5} har gode lese- og skriveferdigheter.',
	localizedwriteuptextforOneOtherSubTest:
		'{0} har oppnådd resultater som ligger {1} {2} {3}. {4} {5} For videre vurdering av resultatene anbefales det å lese {6}, Kapittel 5. Retningslinjer for tolkning.',
	localizedwriteuptextforTwoOtherSubTest:
		'{0} har oppnådd resultater som ligger {1} {2} {3}. {4} Ettersom {5} oppnår svake resultater på {6}, {7} og {8} anbefales derfor Dysmate oppfølgingstest. Dersom {9} på oppfølgingstesten oppnår svake resultater på Arbeidsminne og Hurtigbenevning, anbefales det å gjennomføre en utvidet kartlegging av språkforståelse.  For videre vurdering av resultatene anbefales det å lese {10}, Kapittel 5. Retningslinjer for tolkning.',
	localizedwriteuptextforThreeORMoreOtherSubTest:
		'{0} har oppnådd resultater som ligger {1} {2} {3}. {4} Ettersom {5} oppnår svake resultater på {6}, {7}, {8} {9} {10} {11}  anbefales Dysmate oppfølgingstest. For videre vurdering av resultatene anbefales det å lese {12}, Kapittel 5. Retningslinjer for tolkning.',
	localizedwriteuptextforIncompletedTest:
		'{0} har ikke fullført hele screeningtesten, og det er derfor ikke grunnlag for å komme med noen anbefalinger om videre oppfølging',
	localizedwriteuptextforLowScoreOfOrdiktatWithOneOtherSubTest:
		'Rettskrivingsvansker kan være en indikasjon på dysleksi. {0} sitt resultat på Orddiktat taler for at det gjennomføres Dysmate oppfølgingstest.',
	localizedwriteuptextforLowScoreOfBetyledeWithOneOtherSubTest:
		'Resultatet på Byttelydtesten indikerer at det bør gjøres en nærmere kartlegging av {0} fonembevissthet og fonologisk prosesseringshastighet. Det anbefales derfor å gjennomføre Dysmate oppfølgingstest.',
	localizedwriteuptextforLowScoreInLeseprovenAndOrdforstaelse:
		'{0} har oppnådd resultater som ligger {1} {2} {3}. {4} Ettersom {5} oppnår svake resultater på deltestene ordforståelse og leseprøve anbefales derfor Dysmate oppfølgingstest. For videre vurdering av resultatene anbefales det å lese {6}, Kapittel 5. Retningslinjer for tolkning.',
	info_results_belowpresentsinformation:
		'Nedenfor presenteres testresultatene for {0}{1}{2}',
	info_report_belowpresentsinformation:
		'Nedenfor presenteres testrapport for {0}{1}{2}',
	info_user_belowpresentsinformation:
		'Nedenfor presenteres kandidatopplysninger for {0}{1}{2}',
	newinfo_belowpresentsinformation:
		'Nedenfor presenteres testresultatene for {0}{1}{2}',
	newinfo2_belowpresentsinformation:
		'Nedenfor presenteres testrapport for {0}{1}{2}',
	newinfo3_belowpresentsinformation:
		'Nedenfor presenteres kandidatopplysninger for {0}{1}{2}',
	infor_scr_ageAtCommencement:
		' Alder ved testdato var {0} år og {1} måneder.',
	info_testwascompletedon: ' Testen ble gjennomført {0}',
	info_testwasNotcompletedon: 'Denne testen er ikke komplett.',
	notetsfound: 'Ingen gjennomførte tester funnet',
	candidate_answers: 'Kandidatens svar',
	select_users: 'Velg brukere',
	exportmailingaddress: 'Eksportér adresseliste',
	copyemails: 'Kopier e-post',
	usersupport: 'Brukerstøtte',
	groups: 'Grupper',
	createnewgroup: 'Opprett ny gruppe',
	writegroupname: 'skriv gruppenavn...',
	groupname: 'Gruppenavn',
	date: 'Dato',
	insert: 'Sett inn',
	selected_users: 'Valgte Brukere',
	alreadyexistsingroup: 'finnes allerede i denne gruppen!',
	cannotaddexistingmembertogroup:
		'Kan ikke legge til medlemmer som allerede er i gruppen',
	newgroup: 'Ny gruppe',

	orddiktatheading: `Hvert ord blir først presentert i en setning for å sikre at riktig betydning av ordet er forstått. Deretter blir kandidaten bedt om å skrive det gjentatte stimulusordet. Det er ingen tidsbegrensning på denne testen, og hver setning og stimulusord kan gjentas én gang.`,
	orddiktatchildexplanation: `Det gis ett poeng for hvert riktig svar (maks 13 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	orddiktatvariabletext: `{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,
	orddiktatadultexplanation: `Det gis ett poeng for hvert riktig svar (maks 45 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	orddiktatyouthexplanation: `Det gis ett poeng for hvert riktig svar (maks 30 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	orddiktatChildscrexplanation: `Det gis ett poeng for hvert riktig svar (maks 25 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,

	fonemisolasjonheading:
		'Denne testen kartlegger fonembevissthet hos de yngste elevene. På denne testen blir kandidaten presentert for fire bilder, og blir bedt om å peke på det bildet som enten begynner med, eller slutter på, en bestemt lyd.',
	fonemisolasjonexplanation:
		'Det gis ett poeng for hvert riktig svar (maks 16 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.',
	fonemisolasjonvariabletext: `{0} oppnådde på denne testen en skår på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,

	fonemutelatelseheading: `Denne testen kartlegger fonembevissthet. Kandidaten blir muntlig presentert for ord, og bedt om å si det ordet som blir igjen når en bestemt lyd blir tatt bort.`,
	fonemutelatelseexplanation: `Det gis ett poeng for hvert riktig svar (maks 16 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	fonemutelatelsevariabletext: `{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,

	bokstavkunnskapheading: `Denne testen kartlegger bokstavkunnskap hos de yngste elevene. På denne testen presenteres 15 av bokstavene i det norske alfabetet i tilfeldig rekkefølge. Kandidaten blir så bedt om å si både navnet og lyden til bokstavene. `,
	bokstavkunnskapexplanation: `Det gis ett poeng for hvert riktig svar (maks 15 poeng for lyd og maks 15 poeng for navn, til sammen maks 30 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	bokstavkunnskapvariabletext: `{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,
	bokstavkunnskapvariabletextBH: `{0} oppnådde på denne testen en skåre på {1}. Gjennomsnitt og standardavvik for dette trinnet er ikke tilgjengelig.`,

	spoonerismheading: `Denne testen kartlegger fonembevissthet og fonologisk prosesseringshastighet. Kandidaten blir muntlig presentert for 20 ordpar, og bedt om å bytte om første lyden i de to ordene så raskt og nøyaktig som mulig.`,
	spoonerismexplanation: `Det gis ett poeng for hvert riktig ord kandidaten greier å si med den nye førstelyden (maks 40 poeng). Testen går også på tid. Skåren her er antall riktige ord som har byttet første lyd, dividert med den tiden det tar å gjennomføre oppgavene. Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}. `,
	spoonerismvariabletext: `{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,

	ettminuttstestheading: `Dette er en høytlesningsprøve som kartlegger avkodingsferdighet. Her blir kandidaten presentert for en liste med ord og bedt om å lese så fort og nøyaktig som mulig innen en tidsramme på 60 sekunder. Resultatet her gir et mål på antall riktig leste ord per minutt.`,
	ettminuttstestexplanation: `Det gis ett poeng for hvert riktig leste ord. Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	ettminuttstestvariabletext: `{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,

	hurtigbenevningheading: `Denne testen kartlegger hvor raskt kandidaten greier å benevne kjente objekter, og å gjenhente navn på objekter og farger fra det språklige langtidsminnet.`,
	hurtigbenevningexplanation: `Det gis ett poeng for hver riktig kombinasjon av farge og objekt kandidaten sier. Testen går også på tid. Skåren her er antall riktige farge-objekt-kombinasjoner dividert med den totale tiden det tar å benevne alle 50 farge-objekt-kombinasjonene. Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	hurtigbenevningvariabletext: `{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,
	hurtigbenevningBHexplanation: `Det gis ett poeng for hver riktig kombinasjon av farge og objekt kandidaten sier. Denne testen går også på tid. Skåren her er antall riktige farge-objekt-kombinasjoner dividert med den totale tiden det tar å benevne alle 25 farge-objekt-kombinasjonene. Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,

	arbeidsminnenummberheading: `Denne testen kartlegger testkandidatens evne til å lagre og bearbeide informasjon. På denne testen blir kandidaten først presentert for en serie med tall, deretter en serie med ord, som skal gjentas i omvendt rekkefølge enn de blir presentert. Både tallrekkene og ordrekkene øker i lengde dersom kandidaten mestrer den forrige rekken.`,
	arbeidsminneexplanation: `Det gis ett poeng for hvert riktig svar (maks 12 poeng for tallrekkene og maks 12 poeng for ordrekkene, til sammen maks 24 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	arbeidsminnevariabletext: `{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,
	arbeidsminneheading: `Denne testen kartlegger kandidatens evne til å lagre og bearbeide informasjon, mens man løser en oppgave. Kandidaten blir først presentert for en serie med tall, deretter en serie med ord, som skal gjentas i omvendt rekkefølge enn de blir presentert. Både tallrekkene og ordrekkene øker i lengde.`,

	ordforståelseheading: `Testen måler ordforråd ved at kandidaten må finne et ord som har lik betydning som det gitte stimulusordet. På hver oppgave må kandidaten velge blant fire alternativer. Denne testen gir et mål på bredde og dybde av ordforrådet.`,
	ordforståelseexplanation: `Det gis ett poeng for hvert riktig svar (maks 15 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	ordforståelsevariabletext: `{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,
	ordforståelseyouthexplanation: `Det gis ett poeng for hvert riktig svar (maks 20 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	ordforståelsechildexplanation: `Det gis ett poeng for hvert riktig svar (maks 18 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	leseprøvenheading: `Denne testen er en stillelesingsprøve som måler leseforståelse ved at kandidaten må svare på spørsmål direkte fra teksten og sammenstille informasjon fra ulike avsnitt. Kandidaten får 10 minutter til å lese teksten og svare på så mange flervalgsspørsmål som mulig. NB! I tolkningsarbeidet er det viktig å undersøke hvorvidt testkandidaten har svart feil eller ikke har besvart flervalgsspørsmålene (på grunn av lav lesehastighet).`,
	leseprøvenyouthheading: `Denne testen er en stillelesingsprøve som måler leseforståelse ved at kandidaten må svare på spørsmål direkte fra teksten, sammenstille informasjon fra ulike avsnitt og trekke konklusjoner. Kandidaten får 12 minutter til å lese teksten og svare på så mange flervalgsspørsmål som mulig. NB! Her er det viktig å registrere hvorvidt testkandidaten har svart feil eller ikke har besvart flervalgsspørsmålene (på grunn av sein lesehastighet).`,
	leseprøvenexplanation: `Det gis ett poeng for hvert riktig svar (maks 14 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	leseprøvenvariabletext: `{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,
	reportLeseprovenExtraVariableText: `Kandidaten brukte {0} på å gjennomføre testen.`,
	leseprøvenyouthexplanation: `Det gis ett poeng for hvert riktig svar (maks 9 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	leseprøvenchildheading: `Denne testen er en stillelesingsprøve som måler leseforståelse ved at kandidaten må svare på spørsmål direkte fra teksten, sammenstille informasjon fra ulike avsnitt og trekke konklusjoner. Kandidaten får 10 minutter til å lese teksten og svare på så mange flervalgsspørsmål som mulig. NB! Her er det viktig å registrere hvorvidt testkandidaten har svart feil eller ikke har besvart flervalgsspørsmålene (på grunn av sein lesehastighet).`,
	leseprøvenchildexplanation: `Det gis ett poeng for hvert riktig svar (maks 8 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,

	skrivehastighetheading: `Denne testen måler effektivitet i skriving. Det er en ferdighet som behøves når man for eksempel skal ta notater eller skrive en eksamensbesvarelse. Kandidaten får se en setning foran seg hele tiden, og skal skrive av denne så mange ganger og så nøyaktig som mulig i løpet 2 minutter. `,
	skrivehastighetexplanation: `Skåren her er antall riktig skrevne ord i snitt per minutt. Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	skrivehastighetvariabletext: `{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,

	tulleordtestenheading: `Denne testen er en stillelesingsprøve som måler fonologisk bevissthet og fonologisk prosesseringshastighet. Dette regnes som en språklig-kognitiv markør på dysleksi. Testkandidaten skal finne det tulleordet som høres ut som et ordentlig ord. På hver oppgave må testkandidaten velge blant fem alternativer, hvor bare ett er riktig. Testkandidaten får to minutter til å løse så mange oppgaver som mulig.`,
	tulleordtestenexplanation: `Det gis ett poeng for hvert riktig svar (maks 25 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	tulleordtestenvariabletext: `{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,

	byttelydtestheading: `Denne testen måler fonembevissthet og fonologisk prosesseringshastighet, som er en språklig-kognitiv markør på dysleksi. 
	Testen går ut på at kandidaten skal bytte ut en gitt lyd i ord med en annen lyd, 
	sånn at det blir et nytt ord. For eksempel blir kandidaten bedt om å bytte ut 
	lyden /b/ i «bil» med lyden /p/. På hver oppgave får kandidaten presentert en 
	illustrasjon av hovedordet (f.eks. bil), som så blir etterfulgt av fire illustrerte 
	svaralternativ. Bare ett av alternativene er riktig (her: pil). Kandidaten får 10 
	sekunder til å løse hver oppgave. En ny oppgave dukker automatisk opp på 
	skjermen dersom kandidaten ikke har svart innen tidsfristen.`,
	byttelydtestexplanation: `Det gis ett poeng for hvert riktig svar (maks 21). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	byttelydtestvariabletext: `{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,
	ordkjedetestenheading: `Denne testen er en stillelesingsprøve som måler hurtig ordgjenkjenning og ortografisk kunnskap. Her blir eleven bedt om å lage mellomrom mellom ord som er skrevet sammen til en kjede. Hver kjede består av fire tilfeldige ord. Testkandidaten får 4 minutter til å løse så mange ordkjeder som mulig.`,
	ordkjedetestenexplanation: `Det gis ett poeng for hvert riktig svar (maks 40 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,
	ordkjedetestenvariabletext: `{0} oppnådde på denne testen en skåre på {1}. Denne skåren plasserer seg {2} standardavviksenheter fra gjennomsnittet for trinnet. {3} oppnår dermed et resultat som plasserer seg`,
	ordkjedetestenyouthexplanation: `Det gis ett poeng for hvert riktig svar (maks 36 poeng). Gjennomsnittsskåren for {0} er {1} og standardavviket er {2}.`,

	averageForGrade: 'gjennomsnittsområdet for trinnet.',
	warning_blockuser: 'Er du sikker på at du vil blokkere valgte bruker?',
	warning_unblockuser: 'Er du sikker på at du vil ublokkere valgte bruker?',
	//NewTestModal
	choosegroup: 'Velg gruppe',
	includeLongIntro: 'Inkluder selvrapportering /anamnese',
	fillSelfCandidateInfo: 'Fyll ut informasjon om kandidaten selv',
	createanddistributetests:
		'Ønsker du å sende mange tester samtidig, kan du lime inn e-post adresser i feltet her og trykke "Opprett og send".',
	remembertoprovideemail: 'Husk at epostene  må skilles med komma',
	exmapledemail: 'ola@epost.no, eva@epost.no',
	letCandidateFillInfo: 'La kandidaten fylle ut informasjon selv',
	anamneseexplaination:
		'Dette er en endring innført 22.april. Skal testen brukes som en screening, så er det ikke nødvendig å ha med selvrapportering/anamnese',

	fillKandidateInformation1:
		'Testadministrator (lærer) fyller ut informasjon om kandidaten før eleven logger inn for å ta testen. Kandidaten kommer raskt i gang med testen og kan logge inn med pinkode',
	fillKandidateInformationSelf1:
		'Dette gjør det mulig å sende ut testen direkte på e-post til kandidaten. Kandidaten må logge inn med Feide og fylle ut informasjon om seg selv (Navn, kjønn, fødselsdato og klassetrinn)',
	fillKandidateInformationSelf2:
		'Dette passer typisk for elever på mellomtrinnet som har tilgang til både egen e-post og Feide,  og som skal ta leseprøven.',
	candidateInfoCommon: 'Testkandidaten tar testen på dysmate.no > ta testen.',
	candidateInfoReminder:
		'Merk at pinkoden også er tilgjengelig for testadministrator i oversikten på <<Mine tester>>',
	candidateInfoReminderNorming:
		'Merk at pinkoden også er tilgjengelig for testadministrator i oversikten på <<Normering>>',
	chooselanguage: 'Velg språk',
	//Groups
	warning_deletegroup: 'Er du sikker på at du vil slette denne gruppen?',
	warning_deletemember: 'Er du sikker på at du vil slette dette medlemmet?',
	addtogroup: 'Legg til i en gruppe',
	nogroupsfound: 'Ingen grupper funnet',
	groupalreadyexists: 'Gruppen eksisterer allerede',
	allmytests: 'Alle mine tester',
	groupindicator: 'Grupper',
	//UserStageEditor
	approveuesr: 'Godkjenn bruker',
	sendnewinvitation: 'Send invitasjon på nytt',
	trialperiodexpired: 'Prøveperiode utløpt',
	trialperiodinprogress: 'Prøveperiode pågår',
	extendtrialperiod: 'Utvid prøveperiode',
	message_notallowedemptysubscription:
		'Du kan ikke tildele et tomt abonnement! Slett språket i stedet.',
	savepermission: 'save permission',
	addlanguage: 'Legg Til Språk',
	warning_deleteLanguage: 'Er du sikker på at du vil slette dette språken?',
	//subtestAnswers
	notanswered: 'ikke besvart',
	testnotanswered: '{0} oppgaver ikke besvart',
	showunanswered: 'Vis ubesvarte',
	hideunanswered: 'Skjul ubesvarte',
	rightanswer: 'Rett svar: {0}',
	testdeletedbyuser: 'Testen ble slettet av brukeren',
	testolderthan3years: 'testen er eldre enn 3 år',
	usedon: 'Brukt på',
	reason: 'Årsaken',
	action: 'Handling',
	warning_deleteSingleTest:
		'Dette vil slette testen permanent. Fortsett uansett?',
	warning_deleteAllTest:
		'Dette vil slette alle valgte testene permanent. Fortsett uansett?',
	deleteall: 'Slett alle',
	//Myclasses
	chooseclass: 'Velg klasse',
	confirmationdeleteclass: 'Er du sikker på at du vil slette denne {0}',
	theclass: 'klassen',
	multipleclasses: 'klasser',
	deleteclass: 'Slett klasse',
	message_noclasses: 'Ingen klasser',
	message_noTestsFound: 'Du har ingen slettede tester',
	//My candidates
	showtests: 'Se tester ▼',
	allmycandidates: 'Alle mine kandidater',
	gender: 'Kjønn',
	nocandidates: 'Du har ingen testkandidater',
	choosecandidate: 'Velg kandidat',
	classindicator: 'Kandidater i Klasser:',
	sendtest: 'Send test',
	createTest: 'Opprett test',
	createclass: 'Opprett klasse',
	createdAt: 'Opprettet kl',
	createdOn: 'Opprettet',
	municipalityName: 'Kommune',
	schoolName: 'Skole',
	municipalityNumber: 'Org nr',
	removefromclass: 'Fjern fra Klasse',
	providevalidname: 'Oppgi et gyldig navn',
	searchhere: 'Søk her...',
	searchByTestKey: 'Søk Testnøkkel',
	transferTest: 'Overføringstest',
	searchFeide: 'Feide 2.0',
	searchFeideSchools: 'Feide 2.0 skoler',
	searchConexus: 'Conexus',
	viewMunicipality: 'Se Kommune',
	viewSchools: 'Se Skole',
	addMunicipality: 'Legg til kommune',
	addSchool: 'Legg til Skole',
	createNotification: 'Opprett et varsling',
	viewNotification: 'Se varslinger',
	postNotification: 'Post Notification',
	areyousure: 'Er du sikker?',
	editNotification: 'Rediger Varsling',
	notificationcreated: 'Varsel opprettet',
	municipalityAdded: 'Kommune lagt til',
	schooldAdded: 'Skole lagt til',
	municipalityUpdated: 'Kommunen ble oppdatert!',
	schoolUpdate: 'Skolen ble oppdatert!',
	allnotifications: 'Alle varslinger',
	nonotificationsfound: 'Ingen varslinger funnet',
	noMunicipalityFound: 'Ingen kommune funnet',
	noSchoolsFound: 'Ingen Skole funnet',
	createnotificationwarning:
		'Du kan ikke endre varselet når det først er lagt ut',
	//newcalssmodal
	newclass: 'Ny Klasse',
	writeclassname: 'Skriv klassenavn...',
	chooseagroup: 'Velg en gruppe',
	removefromgroup: 'Fjern fra grupper',
	//testdispatchmodal
	mypage: 'Min side',
	//testadminsummary
	nonewusersduringtimeperiod:
		'Ingen nye kandidater i løpet av denne tidsperioden',
	//subtestReport
	notavailable: 'ikke tilgjengelig',
	theagegroup: 'aldersgruppen',
	hiddenname: '<Skjult navn>',
	wordreadcorrectly: 'riktige ord lest',
	correct: 'Riktig',
	wrong: 'Feil',
	timeused: 'Tid brukt',
	notestsafterdatetoinvoice: 'Ingen tester etter valgte dato å fakturere',
	//
	reminder_bankidregistration:
		'Vi anbefaler at du registrer deg selv med Feide. Hvis du registrerer deg med Bank-ID, må du også bruke Bank-ID for å logge inn til tjenesten videre.  Vil du fortsette uansett?',
	reminder_bankidmobileregistration:
		'Vi anbefaler at du registrer deg selv med Feide. Hvis du registrerer deg med Bank-ID på Mobil, må du også bruke Bank-ID på Mobil for å logge inn til tjenesten videre.  Vil du fortsette uansett?',
	reminderScoreChange:
		'Før du endrer statusen til dette bestemte svaret, vil vi minne deg om at dette vil påvirke kandidatens poengsum',
	correctAnswerConfirmation:
		'Vennligst bekreft hvorvidt ordet var lest riktig eller feil',
	feiderecommended: 'Feide (anbefalt)',
	thisagegroup: 'aldersgruppen',
	cantretrieveaudio: 'Vi kunne ikke finne lydfiler for denne testen',
	adminpersonalinformation: 'Personopplysninger',
	changeToFeide: 'Ja, jeg ønsker å bytte til Feide ',
	changeToFeide2: 'Ja, jeg ønsker å bytte til Feide 2.0 ',
	testredistributed:
		'Testen er sendt til kandidaten. Ny pinkode er {0} (Hvis kandidaten skal logge inn med e-post)',
	testCandidateTakeTestWith: 'Testkandidatene/elevene tar testen ved å',
	gotoDysmtateSite: 'Gå til dysmate.no',
	testCommenceInstructions1:
		'Velge «ta testen» og velge «Screeningtest for barn»',
	normingCommenceInstructions1: 'Velge «ta testen» og velge «{0}»',
	testCommenceInstructions2: 'Skrive inn testnøkkelen',
	testCommenceInstructions3: 'Logge inn med Feide eller Pinkode.',
	testCommenceInstructions4:
		'E-post er valgfritt. Hvis dette feltet er tomt må du selv fortelle testkandidaten/eleven pinkoden.',
	testCommenceInstructions5:
		'Hvis du skriver inn en e-postadresse, så sendes både testnøkkelen og pinkode til e-postadressen',
	question_excludeReadingTest:
		'Vil du utelukke deltesten leseprøve? Denne kan ekskluderes for barn som ikke kan lese',
	fillOutInfo: 'Fyll ut informasjon',
	homeLanugage: 'Hjemmespråk',

	printInformation: 'Print opplysninger',
	highestEducation: 'Høyeste fullførte utdanning:',
	otherCompetence: 'Annen utdanning:',
	goesToHighSchool: 'Går på videregående skole: ',

	warning2: 'Advarsel 2',
	warning2text:
		' - Det ser ut til at du har deaktivert sporing på tvers av nettsteder i nettleseren din. Dette er nødvendig for å bruke Dysmate dysleksitester. ',
	linkForInstructions: ' Her',

	warning_text_end: ' er en oppskrift for hvordan du skrur dette på.',
	//Enrollment
	message_first_login: `Hvis du aldri har logget inn før på {0}, så må du fullføre din registrering.`,
	message_initial_approval: `Vi har godkjent deg basert på den eposten du oppga når du tok sertifiseringskurset.`,
	message_provide_email: `Tast inn denne eposten i feltet under, så sender vi deg registrerings lenken.`,
	info_registration_eamil_sent: `Flott! Vi har nå sendt deg en registreringslenke på e-posten du oppga.`,
	message_not_yet_approved: `Vi finner ingen godkjente testadministratorer med den e-posten som du oppga. Dette kan skyldes at vi ikke har godkjent deg som testadministrator enda. Dette tar typisk 1-3 dager fra man melder seg på kurs.`,
	message_user_not_found: `Vi finner ingen kursdeltagere med den e-posten som du oppga. Dette kan skyldes at du brukte en annen e-post når du registrerte deg for sertifiseringskurset.`,
	message_user_already_registered: `Det ser ut som om du allerede har fullført registreringen din.  Logg inn med {0} {1}.`,
	message_trial_period_expired: `Din prøveperiode er utløpt. Ta kontakt med oss for å tegne et abonnement.`,
	message_try_loggin_in: `Det ser ut som om du allerede har fullført registreringen din.  Logg inn {0}.`,
	no_tests_available_message: 'Du har ingen tester.',
	somthingWentWrong: 'Oops! Noe gikk galt.',
	testDistributedSuccessfully: 'Tester distribuert vellykket',
	results: 'Resultater',
	screeningTest: 'Screeningtest',
	followUpTest: 'Oppfølgingstest',
	classOverview: 'Klasseoversikt',
	testCandidate: 'Testkandidat',
	resultsReport: 'Resultatrapport',
	spoonerism: `Spoonerism`,
	oneminute: `Ettminutttest`,
	redAverageArea: `Rød: Z-skåre under gjennomsnittetsområdet`,
	yellowAverageArea: `Gul: Z-skåre innenfor gjennomsnittsområdet`,
	greenAverageArea: `Grønn: Z-skåre over gjennomsnittetsområdet`,
	for: `for`,
	seeTests: `Se Tester ▼`,
	wordchain: 'Ordkjede',
	activityTab: 'Aktivitet',
	add: ' Legg til',
	addNotesBeforePrintTitle: 'Vil du legge til notater før utskrift?',
	addToExistingClass: 'Legg til i eksisterende klasse',
	addYourNotesTitle: 'Legg til notatene dine',
	administratorLabel: 'Administrator: ',
	adultFollowupLabel: 'Adult Followup',
	adultTestsLabel: 'Adult Tests',
	alert_cannotDeleteClassNotOwned: 'Det er ikke tillatt å slette en klasse som ikke er opprettet av deg.',
	alert_nothingSelected: 'Du har ikke valgt noe!',
	allMyClasses: 'Alle mine klasser',
	answerDoesNotKnow: 'Vet ikke',
	answeredDash: '– besvart:',
	answersJson: 'Answers JSON',
	availableTests: 'Tilgjengelige tester',
	averageZScore: 'Gjennomsnittig Z-skåre',
	bachelor: 'Bachelor',
	basisHeader: 'Basis',
	blockedStatus: 'Blocked',
	bulkSending: 'Bulkutsending',
	cancelPrintNotes: 'Kansellere',
	candidateDifficultiesQuestion: 'Har eleven tidligere fått en diagnose eller vært utredet for lese-/skrivevansker (dysleksi) eller språkvansker (DLD)?',
	candidateFirstLanguageQuestion: 'Har kandidaten et annet språk enn norsk som sitt førstespråk?',
	candidateInfoHeadingLine1: 'Opplysninger om ',
	candidateInfoHeadingLine2: 'testkandidaten (eleven)',
	candidateInfoInstructions: 'Instruksjoner for kandidatinfo',
	candidateInfoUpdated: 'Kandidatinfo oppdatert',
	candidateInfoUpdatedSuccessfully: 'Candidate information updated successfully',
	candidateMustCompleteOneSubtest: '{0} er nødt til å gjennomføre minst én av deltestene for at vi skal kunne gi en vurdering. Testen kan gjenopptas fra «Mine tester»',
	candidateNoSubtestsCompleted: '{0} har ikke gjennomført noen deltester.',
	candidates: 'Kandidater',
	candidatesAlreadyInSelectedClass: 'kandidat(er) finnes allerede i den valgte klassen.',
	candidatesGetTestWithoutGroup: 'Kandidatene får test uten gruppetilknytning.',
	candidatesSelectedSuffix: 'kandidat(er) valgt',
	candidatesWillBeAddedToClass: 'Disse kandidatene vil bli lagt til i klassen.',
	candidatesWillGetNewTest: 'Disse kandidatene vil få den nye testen.',
	childAndAdultTests: 'Barn og Voksentester',
	childAndYouthTests: 'Barn og Ungdomtester',
	childTestsLabel: 'Child Tests',
	childYouthAndAdultTests: 'Barn, ungdom og voksentester',
	chooseAction: 'Velg handling',
	chooseOwnedClassAndAddCandidates: 'Velg en klasse du eier og legg til kandidatene der.',
	classGradeColon: 'Klassetrinn: ',
	classHasNoTestResults: 'Denne klassen inneholder ingen testresultater',
	className: 'Klassenavn',
	classesInGroups: 'Klasser i grupper:',
	commentWrittenByAdministrator: 'Kommentaren er skrevet av testadministrator:',
	commentsLabel: 'Kommentarer:',
	confirmCreateNewTestForSelected: 'Bekreft at du vil opprette ny test for de valgte kandidatene.',
	confirmDispatch: 'Bekreft utsending',
	createAndSend: 'Opprett og send',
	createCandidateInfo: 'Lage opplysninger',
	createNewClass: 'Opprett ny klasse',
	createNewClassWithSelectedCandidates: 'Opprett en ny klasse med de valgte kandidatene.',
	createNewNotificationHeading: 'Create a new notification',
	createNormingTest: 'Opprett normeringstest',
	delayedDash: '– Forsinket:',
	delayedLabel: 'Forsinket:',
	deleteOldAndDeletedTests: 'Slett gamle og slettede tester',
	deleteSubtest: 'Delete Subtest',
	deletedUser: '--Slettet bruker---',
	distributedNotCompleted: 'Distribuert/ikke fulført',
	dysmateCChildScreening: 'Dysmate - C (Screeningtest for barn)',
	editCandidateInformation: 'Edit candidate information',
	editSubtestResult: 'Edit Subtest Result',
	educationLevel: 'Utdanningsnivå',
	emptyStateNoSubtestsBody: 'Det ser ut som testen ble opprettet, men testkandidaten logget aldri inn for å gjennomføre deltestene.',
	enterTestKeyLabel: 'Enter Test Key:',
	enterTestKeyPlaceholder: 'Skriv testnøkkel... ',
	enterYourNotesHerePlaceholder: 'Skriv inn notatene dine her...',
	error_notFoundLabel: 'Ikke funnet:',
	error_unauthorizedLabel: 'Uautorisert:',
	errorsLabel: 'Feil:',
	feideButton: 'Feide',
	firstNameLastNameHeader: 'Fornavn, Etternavn',
	followUpColumn: 'Oppfølging',
	forExample: 'f.eks.',
	fullSubscriptionLabel: 'Fullt',
	genderBoy: 'Gutt',
	genderGirl: 'Jente',
	genderOther: 'Annet',
	grade1: '1. klasse',
	grade10: '10. klasse',
	grade2: '2. klasse',
	grade3: '3. klasse',
	grade4: '4. klasse',
	grade5: '5. klasse',
	grade6: '6. klasse',
	grade7: '7. klasse',
	grade8: '8. klasse',
	grade9: '9. klasse',
	gradeTrinn2: '2. Trinn',
	gradeTrinn3: '3. Trinn',
	gradeTrinn4: '4. Trinn',
	gradeTrinn5: '5. Trinn',
	gradeTrinn6: '6. Trinn',
	gradeTrinn7: '7. Trinn',
	greetingHello: 'Hei!',
	grownUpMonoOrBilingual: 'Har vokst opp i ett- eller to-språklig hjem?',
	handbook: 'Håndbok',
	handbookUpper: 'HÅNDBOK',
	hiddenValue: 'Skjult',
	hideAudio: 'Skjul Audio',
	immediateLabel: 'Umiddelbar:',
	info_productImprovementsMay2024: '8.mai 2024 har vi lansert noen produktforbedringer. Les mer {0}',
	invalidJson: 'Invalid JSON',
	invalidJsonFormat: 'Invalid JSON format',
	invalidSubtestSelection: 'Invalid subtest selection.',
	invoiced: 'Fakturert',
	invoicedTestsHeader: 'Fakturerte tester',
	invoicesUnderDevelopment: 'Under utvikling Invoices...',
	invoicingTab: 'Fakturering',
	languageDutch: 'Dutch',
	languageEnglish: 'Engelsk',
	languageGerman: 'Tysk',
	languageNorwegian: 'Norsk',
	languageSwedish: 'Svensk',
	lastInvoicedOnHeader: 'Sist fakturert på',
	lastYearBeforeSchool: 'Siste år før skolestart',
	listenToWords: 'Lytt til ordene',
	loginMethodSingular: 'Innloggingsmetode',
	loginMethodSingularLower: 'innloggingsmetode',
	loginMethodsPlural: 'Innloggingsmetoder',
	loginMethodsPluralLower: 'innloggingsmetoder',
	loginWithPinCodeInstruction: 'Logge inn med Pinkode.',
	markTestAsComplete: 'Mark Test As Complete',
	markTestAsIncomplete: 'Mark Test As Incomplete',
	markTestConfirmQuestion: 'Are you sure you want to mark this test?',
	markTestTitle: 'Mark Test',
	masterDegree: 'Mastergrad',
	message_noTestsForFilter: 'Du har ingen < {0} > tester',
	multipleLanguages: 'Flere språk',
	neverInvoiced: 'Aldri fakturert',
	newCandidate: 'Ny Kandidat',
	newCandidateModalPlaceholder: 'NewCandidateModal',
	newUserCompleteRegistration: 'Ny bruker? Fullføre din registrering {0}',
	no: 'Nei',
	noClassAvailable: 'Ingen klasse tilgjengelig',
	noGroupSelected: 'Ingen gruppe valgt',
	noTestResultsBody: 'Det ser ut som testen ble startet, men testkandidaten logget aldri inn for å gjennomføre deltestene.',
	noTestResultsErrorBody: 'Ops! Klarte ikke å hente data. Det ser ut som testen ble startet, men testkandidaten logget aldri inn for å gjennomføre deltestene.',
	noTestResultsHint: 'Tips: Sjekk at invitasjonen er sendt og at e-postadressen er riktig.',
	noTestResultsTitle: 'Ingen testresultater',
	normingHeader: 'Normering',
	normingLabel: 'Norming',
	normingTests: 'Normeringstester',
	notAnsweredCap: 'Ikke besvart',
	notAvailableMisspelled: 'ikke tilgjengellig',
	notUsed: 'Ikke brukt',
	notificationUpdatedSuccessfully: 'Notification updated successfully',
	numberOfCandidates: 'Antall kandidater',
	ofMax: 'av maks',
	oneLanguage: 'Ett språk',
	opsNoeGikkGalt: 'Ops! Noe gikk galt.',
	otherLabel: 'Other',
	pasteEmailsPlaceholder: 'lim inn e-poster, en e-post pr linje',
	percentileLabel: 'Percentile',
	phdDegree: 'Doktorgrad (PhD)',
	pinCode: 'Pinkode',
	pinCodeLabel: 'Pinkode:',
	placeholderOrganizationExample: 'Kongsbakken vgs',
	placeholderPhoneExample: '987 65 432',
	pleaseEnterValidTestKey: 'Please enter a valid test key',
	pointsLabel: 'Poeng:',
	pointsOf: 'poeng av',
	pointsWord: 'poeng',
	printWithNotes: 'Skriv ut med notater',
	productionAndNorming: 'Produksjon & Normering',
	productionLabel: 'Production',
	productionTests: 'Produksjonstester',
	registrationUrl: 'Registration URL',
	reloadButton: 'Last inn på nytt',
	report: 'Rapport',
	savedByLabel: 'Lagret av: ',
	scaledScoreLabel: 'Scaled Score',
	scheduleNotificationLabel: 'Schedule a notification:',
	scores: 'Scores',
	screeningColumn: 'Screening',
	screeningTestAdultName: 'Screeningtest for voksen',
	screeningTestChildName: 'Screeningtest for barn',
	screeningTestYouthName: 'Screeningtest for ungdom',
	screeningsFollowupsHeader: 'Screeninger - Oppfølginger',
	searchHereTrailingSpace: 'Søk her... ',
	seeOverview: 'Se oversikt :',
	selectEducationLevelPlaceholder: '-Velg utdanningsnivå-',
	selectGradePlaceholder: '-Velg trinn-',
	selectedCandidates: 'Valgte kandidater',
	selectedCandidatesSuffix: 'valgte kandidater',
	selectedDateLabel: 'Valgte dato: ',
	selectedTestCandidates: 'Valgte testkandidater',
	sendInvoiceButton: 'Send faktura ➤',
	showPinCode: 'Vis pinkode',
	sinceLastInvoicedHeader: 'Siden sist fakturert',
	standardScoreLabel: 'Standard Score',
	statusActive: 'Active',
	statusExpired: 'Expired',
	statusInactive: 'Inactive',
	statusNotCompletedRegistration: 'Not completed registration',
	statusWaitingForApproval: 'Waiting for approval',
	studyPreparation: 'Studiespesialisering',
	subjectLabel: 'Subject:',
	subtestDeletedSuccessfully: 'Subtest deleted successfully',
	subtestResultsUpdatedSuccessfully: 'Subtest results updated successfully',
	subtestsTransferredSuccessfully: 'Subtests transferred successfully',
	summaryLabel: 'Summary:',
	summaryTab: 'Oppsumering',
	tScoreLabel: 'T Score',
	takeOver: 'Overta',
	tasksNotAnswered: '{0} oppgaver ikke besvart',
	tasksNotAnsweredSuffix: 'oppgaver ikke besvart',
	testInformationUpdatedSuccessfully: 'Test information updated successfully',
	testLinkedToSelectedGroup: 'Testen knyttes til valgt gruppe.',
	testName: 'Testnavn',
	testResultsExportedToConexus: 'Testresultater eksportert til Conexus',
	testSettings: 'Testinnstillinger',
	testsCompleted: 'Tester gjennomført',
	totalColon: 'Totalt:',
	totalCorrectCount: 'Antall total riktig',
	totalCorrectLabel: 'Total Correct',
	totalDash: '– Total:',
	totalLabel: 'Total:',
	totalTestsHeader: 'Totalt tester',
	transferClickUsersHelper: 'Click users below to select multiple.',
	transferDestinationLabel: 'Transfer Destination:',
	transferFailedTryAgain: 'Transfer failed. Please try again.',
	transferFromUsersLabel: 'From Users:',
	transferMustSelectSourceUser: 'You must select at least one user to transfer from.',
	transferNoGroupsFound: 'No groups found',
	transferSearchGroupsPlaceholder: 'Search groups...',
	transferSearchSelectGroupHelper: 'Search or select a group:',
	transferSelectDestinationGroup: 'Please select a destination group.',
	transferSelectDestinationUser: 'Please select a destination user.',
	transferSelectSourceAndTarget: 'Please select at least one source and one target.',
	transferSelectTargetUserHelper: 'Select a target user:',
	transferSelectUserPlaceholder: '-- Select a user --',
	transferServerError: 'Server error: Unable to transfer tests.',
	transferSubtestsTitle: 'Transfer Subtests',
	transferTestsButton: 'Transfer Tests',
	transferToGroupOption: 'To Group',
	transferToUserOption: 'To User',
	transferUsersSelectedCount: 'user(s) selected',
	twoLanguages: 'To språk',
	unansweredColon: 'ubesvart:',
	uninvoicedTestsHeader: 'Ufakturerte tester ',
	unspecified: 'Uspesifisert',
	userNeverInvoiced: 'Denne brukeren har aldri blitt fakturert',
	usersLoggedOutForcefully: 'users logged out forcefully!',
	usersUnblockedSuccessfully: 'users unblocked successfully!',
	validation_birthDateInvalid: 'Fødselsdato er ikke riktig',
	vocational: 'Yrkesfag',
	warningDeleteSubtest: 'Are you sure you want to delete this subtest?',
	writeYourContentPlaceholder: 'write your content ....',
	yearsOld: 'år gammel',
	yes: 'Ja',
	youthAndAdultTests: 'Undgom og Voksentester',
	youthFollowupLabel: 'Youth Followup',
	youthTestsLabel: 'Youth Tests',
	zScoreLabel: 'Z Score',
	error_registrationKeyUnauthorizedMsg: 'Registreringsnøkkel {0} er allerede brukt. Prøv å logge inn på {1} ➜ testleder.',
	error_registrationKeyNotFoundMsg: 'Registreringsnøkkel {0} eksisterer ikke. Prøv lenken sendt på e-post, eller trykk {1}',
	currentLoginMethodSentence: 'Din nåværande {0} er [{1}] Ønsker du å endre Innloggingsmetode ? (Anbefalt)',
	opsSomethingWentWrong: 'Ops! something went wrong.',
	opsSomethingWentWrongCap: 'Ops! Something went wrong.',
	// Strings configuration (super admin)
	configurations: 'Strengkonfigurasjon',
	configSearchPlaceholder: 'Søk etter nøkkel...',
	configAllaOption: 'Alle',
	configOverriddenOption: 'Overstyrt',
	configCacheNote: 'Endringer synlige for alle brukere innen 5 minutter (cache-TTL)',
	configRefresh: 'Oppdater',
	configLastEdited: 'Sist endret: ',
	configEditedBy: ' av ',
	configKeysFound: '{0} nøkler funnet',
	configKeysSummary: '{0} nøkler · {1} overstyrt',
	configNoOverriddenKeys: 'Ingen overstyrte nøkler for {0} ennå.',
	configNoKeysMatch: 'Ingen nøkler samsvarer med søket ditt.',
	configKeyHeader: 'Nøkkel',
	configValueHeader: 'Verdi',
	configOverriddenBadge: 'overstyrt',
	configEditTitle: 'Rediger',
	configDefaultLabel: 'Standard:',
	configRequiredPlaceholders: 'Påkrevde plassholdere: ',
	configCannotSaveWarning: '⚠ Kan ikke lagre — legg tilbake de manglende plassholderne:',
	configBelongsHere: ' hører hjemme her: ',
	configAddMissingPlaceholders: 'Legg til manglende plassholdere: {0}',
	configSaveLabel: 'Lagre',
	configSavingLabel: 'Lagrer...',
	configSavedConfirm: 'Lagret ✓',
	configResetToDefault: 'Tilbakestill til standard',
	configCancel: 'Avbryt',
	warning_deleteSchool: 'Er du sikker på at du vil slette denne skolen?',
	schoolDeleted: 'Skole ble slettet!',
	editSchoolTitle: 'Rediger skole',
	deleteSchoolTitle: 'Slett skole',
	editMunicipalityTitle: 'Edit Municipality',
	deleteMunicipalityTitle: 'Delete Municipality',
	environmentBannerNote: 'NOTE: THIS IS A {0} ENVIRONMENT',
	warning_deleteMunicipality: 'Er du sikker på at du vil slette denne kommunen?',
	municipalityDeleted: 'Kommunen ble slettet!',
	okButton: 'OK',
	controlPanelMenu: 'Kontrollpanel',
	followUpTestsMenu: 'Oppfølgingstester',
	trialExpiresInPrefix: 'Utløper om {0}',
	trialExpiredShort: 'Utløpt',
	notificationsMenu: 'Varslinger',
	validUntilDate: 'Gyldig frem til {0}',
	expiredOnDate: 'Utløpte den {0}',
	statusHeading: 'Status',
	warning_deleteNotification: 'Er du sikker på at du vil slette dette varslinget?',
	notificationDeletedSuccessfully: 'Notification deleted successfully!',
	notificationScheduledAt: 'Notification Scheduled at: {0}',
	editNotificationTitle: 'Edit Notification',
	deleteNotificationTitle: 'Delete Notification',
	configFailedToSave: 'Failed to save {0}',
	configFailedToReset: 'Failed to reset {0}',
	testsTab: 'Tester',
	childFollowupLabel: 'Child Followup',
	feideTwoPointZero: 'Feide 2.0',
	switchToFeideTwoInstructions: 'Du har nå valgt å bytte til Feide 2.0. Vennligst start med å identifisere deg selv. Husk å bruke samme metode som du bruker for å logge på.',
	switchToOtherMethodInstructions: 'Du har nå valgt å bytte til en annet identifiseringsmetode. Vennligst start med å identifisere deg selv. Husk å bruke samme metode som du bruker for å logge på.',
	switchTo: 'Bytt til ',
	loginWithFeide: 'Logg inn med Feide',
	unableToChangeLoginMethodError: 'Unable to change login Method: Error::',
	pleaseTryAgainLater: 'Please try again later.',
	removeTestFromGroupExplanation: 'Hvis testen er delt i en gruppe, vil dette fjerne testen fra gruppen den er lagt til. ',
	noCandidatesForSelectedOption: 'Det ser ut til at du ikke har ingen kandidater for det valgte valget',
	notProvided: 'Ikke oppgitt',
	seeTestsPlain: 'Se tester',
	cannotEditSelectedOption: 'Det er ikke tillat a endre noe for det valgte valget',
	candidatesInGroupsColon: 'Kandidater i grupper:',
	notPlacedInClass: 'ikke lagt i klasse:',
	candidatesLowercase: 'kandidater',
	chooseRestartOrSeeResults: 'Velg enten gjenstarte test eller se resultater',
	redistributeButton: '\'Redistributere\'',
	seeResultsButtonQuoted: '\'Se Resultater\'',
	testSentToCandidate: 'Testen er sendt til kandidaten',
	testDeleted: 'Testen er slettet',
	candidateInfoSavedTestReadyWithPin: 'Informasjonen til kandidaten er lagret. Testen er klar og kan startes med pinkoden {0}',
	candidateInfoSavedTestReady: 'Informasjonen til kandidaten er lagret. Testen er klar og kan startes med pinkoden.',
	newClassCreatedCap: 'Ny Klasse opprettet',
	adminColumnHeader: 'Admin',
	candidatesAddedToGroup: ' kandidater lagt til i gruppen',
	myCandidatesTab: 'Mine kandidater',
	myClassesTab: 'Mine klasser',
	feidePortalClosed: 'lukket',
	feidePortalOpen: 'åpnet',
	couldNotLogIn: 'Kunne ikke logge inn!',
	confirmLoginMethodFirst: 'Du må først bekrefte innloggingsmetoden din. Klikk på Personlig informasjon når du blir omdirigert.',
	logInWithBankId: 'Logg inn med BankID',
	redistribute: 'Redistributere',
	seeResultsCap: 'Se Resultater',
	testsPluralWord: 'tester',
	followupTestIpadImprovementNotice: 'NB: Oppfølgingstesten er under forbedring for iPad. Inntil videre må derfor både testleder og testkandidat bruke PC ved gjennomføring av oppfølgingstester. Dersom dere kun har iPad tilgjengelig, må Google Chrome benyttes. Vi gir beskjed så snart forbedringene for iPad er klar.',
	confirmDeleteSubtestPermanently: 'Er du sikker på at du vil slette denne deltesten permanent?',
	secondsSuffix: '{0} sekunder',
	minutesSecondsLabel: '{0} minutter {1} sekunder',
	correctOfPossible: '{0}  rette av {1} mulige',
	timeUsedAndErrorsLabel: '\\nTid brukt: {0} sekunder\\nAntall feil: {1}',
	correctOf40InSeconds: '{0} rette av 40 mulige på {1} sekunder\\n',
	scoreOfTotal: '{0} av {1}',
	ageYearsAndMonths: '{0} år og {1} {2}',
	countyColon: 'Fylke: ',
	municipalityColon: 'Kommune: ',
	schoolColon: 'Skole: ',
	dyslexiaConfirmationLink: 'Bekreftelse på dysleksi',
	resourceBookletDysmateLink: 'Ressurshefte Dysmate',
	totalCorrectRette: '{0}  rette',
	timeUsedSecondsAndErrors: '\\n{0}: {1} sekunder\\nAntall feil: {2}',
	timeUsedSecondsAndErrorsLiteral: '\\nTid brukt: {0} sekunder\\nAntall feil: {1}',
	totalCorrectRetteOf40OnSeconds: '{0} rette av 40 mulige på {1} sekunder\\n',
	educationJuniorHigh: 'Ungdomsskole',
	educationHighSchool: 'Videregående',
	educationMaster: 'Master',
	educationPhd: 'PhD',
	measureYouthProgram: 'Ungdomsprogram',
	measureAccompanyingMeasures: 'Oppfølgingstiltak',
	measureWorkPreparatoryTraining: 'Arbeidsforberedende trening',
	studyPreparingProgram: 'Studiespesialiserende',
	ageYearsAndMonthsShort: '{0} år og {1} {2}',
	nameColonNoSpace: 'Navn:',
	dateOfCompletion: 'Dato for gjennomføring: ',
	emailColon: 'E-post:',
	telephoneColon: 'Telefon:',
	ageAtCompletion: 'Alder ved gjennomføring:',
	genderColon: 'Kjønn:',
	educationProgramColon: 'Utdanningsprogram: ',
	onWorkAssessmentAllowanceQuestion: 'Er du på arbeidsavklaringstiltak? ',
	measureColon: 'Tiltak: ',
	adultEducationQuestion: 'Tar du voksenopplæring (videregående for voksne over 25 år)? ',
	higherEducationQuestion: 'Tar du høyere utdanning, for eksempel på høyskole eller universitet? ',
	grewUpBilingualHomeQuestion: 'Har du vokst opp i et to-språklig hjem? ',
	readingAndWritingHeading: 'Lesing og skriving',
	childDiagnosedReadingWritingQuestion: 'Har barnet fått påvist lese- og skrivevansker? ',
	childSuspectedReadingWritingQuestion: 'Har barnet vært mistenkt for lese- og skrivevansker av PPT eller andre? ',
	difficultiesWithIntro: 'Har du vansker med å:',
	difficultyReadWordsCorrectly: 'lese ordene riktig? ',
	difficultyReadLongTexts: 'lese lange tekster? ',
	difficultyRememberWhatRead: 'huske hva du har lest? ',
	difficultyWriteWordsCorrectly: 'skrive ordene riktig? ',
	difficultyGetThoughtsOnPaper: 'få «tankene ned på papiret»? ',
	difficultyReadWriteEnglish: 'lese og skrive på engelsk? ',
	assessedReadingWritingQuestion: 'Har du vært utredet for lese- og skrivevansker av PPT eller andre? ',
	hasDyslexiaDiagnosisQuestion: 'Har du en diagnose, f.eks. dysleksi eller spesifikke lese- og skrivevansker? ',
	suspectsDyslexiaQuestion: 'Mistenker du selv at du har dysleksi? ',
	familyReadingWritingDyslexiaQuestion: 'Har noen i din nærmeste familie (slektninger) lese- og skrivevansker eller dysleksi? ',
	rateReadingWritingSkillsQuestion: 'Hvordan vil du rangere dine egne lese- og skriveferdigheter på en skala fra 1-6, hvor 1 er svært dårlig og 6 er svært bra? ',
	clearlyBelowOnNofSubtests: 'klart under på {0} av {1}',
	significantlyBelowOnNofSubtests: 'betydelig under på {0} av {1}',
	clearlyAndSignificantlyBelowOnSubtests: 'klart under på {0} av {1} og betydelig under på {2} av {3} ',
	remainingSubtestsWithinOrAboveAverage: 'På {0} {1} oppnår {2} {3} innenfor eller klart over gjennomsnittsområdet.',
	dysmateHandbook: 'Dysmate Håndbok',
	withinAndClearlyOver: 'innenfor og klart over ',
	standardScoreLabelNo: 'Standard skåre',
	minutesColonSeconds: '{0}:{1} minutter',
	firstLanguageQuestion: 'Hva er ditt 1.språk? ',
	otherFirstLanguageLabel: 'Annet 1. språk ',
	secondLanguageQuestion: 'Hva er ditt 2.språk? ',
	otherSecondLanguageLabel: 'Annet 2. språk ',
	troubleRememberingWordQuestion: 'Har du vansker med huske hvilket ord du skal si, når du snakker? ',
	shufflesWordsQuestion: 'Stokker du ofte om på ordene når du prater? ',
	longTimeFormulatingQuestion: 'Bruker du lang tid på å formulere deg riktig, når du snakker? ',
	suspicionLanguageDifficultiesQuestion: 'Har det noen ganger vært mistanke om at du har språkvansker? ',
	assessedLanguageDifficultiesQuestion: 'Har du vært utredet for språkvansker av PPT eller andre? ',
	diagnosisLanguageQuestion: 'Har du en diagnose, f.eks. spesifikke språkvansker? ',
	suspectLanguageDifficultiesQuestion: 'Mistenker du selv at du har språkvansker? ',
	familyLanguageDifficultiesQuestion: 'Har noen i din nærmeste familie (slektninger) språkvansker? ',
	rateOwnOralLanguageQuestion: 'Hvordan vil du rangere dine egne muntlige språkferdigheter på en skala fra 1-6, hvor 1 er svært dårlig og 6 er svært bra? ',
	mathHeading: 'Matematikk',
	mathDifficultiesQuestion: 'Har du vansker med regning eller matematikk? ',
	assessedMathDifficultiesQuestion: 'Har du vært utredet for matematikkvansker av PPT eller andre? ',
	diagnosisDyscalculiaQuestion: 'Har du en diagnose (f.eks. dyskalkuli eller spesifikke matematikkvansker)? ',
	suspectDyscalculiaQuestion: 'Mistenker du selv at du har dyskalkuli? ',
	familyMathDyscalculiaQuestion: 'Har noen i din nærmeste familie (slektninger) mattevansker eller dyskalkuli? ',
	rateOwnMathQuestion: 'Hvordan vil du rangere dine egne matematikkferdigheter på en skala fra 1-6, hvor 1 er svært dårlig og 6 er svært bra? ',
	concentrationHeading: 'Konsentrasjon',
	concentrationStaminaQuestion: 'Har du problemer med konsentrasjon og utholdenhet? ',
	easilyBoredRestlessQuestion: 'Kjeder du deg lett og blir rastløs? ',
	assessedAddAdhdQuestion: 'Har du vært utredet for ADD eller ADHD? ',
	diagnosisAddAdhdQuestion: 'Har du en diagnose (f.eks. ADD eller ADHD)? ',
	suspectAddAdhdQuestion: 'Mistenker du selv at du har ADD eller ADHD? ',
	familyAddAdhdQuestion: 'Har noen i din nærmeste familie (slektninger) diagnosen ADD eller ADHD? ',
	rateOwnConcentrationQuestion: 'Hvordan vil du rangere din generelle konsentrasjonsevne på en skala fra 1-6, hvor 1 er svært dårlig og 6 er svært bra? ',
	remainingOnesNn: 'dei resterande',
	subtestsNn: 'deltestane',
	resultsNn: 'resultat',
	remainingOnes: 'de resterende',
	subtestsWord: 'deltestene',
	resultsWord: 'resultater',
	selectedEmailHeading: 'Valgt E-post',
	followupAllOption: 'Oppfølging (alle)',
	screeningAllOption: 'Screening (alle)',
	childFollowupOption: 'Child-followup',
	childScreeningOption: 'Child-screening',
	youthFollowupOption: 'Youth-followup',
	adultScreeningOption: 'Adult-screening',
	adultFollowupOption: 'Adult-followup',
	error_loggingInGeneric: 'There was an error logging you in',
	ageMonthsSuffix: ' og {0} mnd',
	ageYearsLabel: '{0} år{1}',
	undistributedTests: 'Udistribuerte tester',
	unknownDate: 'Ukjent dato',
	handbookDysmateLink: 'Håndbok Dysmate',
	gradeColonLabel: 'Trinn: ',
	correctOf40OnSeconds: '{0} rette av 40 mulige på {1} sekunder',
	clickToSelectDate: 'Klikk for å velge dato',
	simulateResults: 'Simuler resultater',
	simulateTestType: 'Test type',
	simulateTestTypeValue: 'Child Screening (NO)',
	simulateGrade: 'Grade',
	simulateGender: 'Gender',
	simulateGenderMale: 'Male',
	simulateGenderFemale: 'Female',
	simulateForeign: 'Foreign language background',
	simulateForeignYes: 'Yes',
	simulateForeignNo: 'No',
	simulateSelectGrade: '-- Select grade --',
	simulateSelectGender: '-- Select gender --',
	simulateSelect: '-- Select --',
	simulateSubtestsHeading: 'Subtest Scores',
	simulateSubtest1: 'Word Dictation',
	simulateSubtest2: 'Word Chain',
	simulateSubtest3: 'Swap Soundtest',
	simulateSubtest4: 'Writing Efficiency',
	simulateSubtest5: 'Reading Comprehension',
	simulateSubtest6: 'Word Comprehension',
	simulateSubmit: 'Simulate',
	simulateSubmitting: 'Simulating...',
	simulateResultsHeading: 'Simulated Results',
	simulateGenericError: 'An error occurred while simulating the test result.',
};
